import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack } from '@fluentui/react';
import { FormSectionCard } from '../FormSectionCard';
import { Header } from '../Header';
import { FormFooter } from '../FormFooter';
import { FormError } from '../FormError';
/**
 * A prestyled card-stack layout to make all of MSRC's forms look and feel the
 * same. This is just a layout/UI component, bring your own <form/> tags and
 * state manager. This is done intentionally so you have the option to compose
 * this UI within other layout components.
 *
 * > Note: Use FormSectionCard for the content cards. (For ease of use, this is
 * > provided to you as FormLayout.Card)
 */
export const FormCardStackLayout = ({ children, detailedErrorMessage, title, subtitle, titleAs = 'h1', }) => {
    return (
    // Stack in this instance, also provides a scroll pane.
    _jsxs(Stack, Object.assign({ horizontalAlign: 'center', verticalFill: true, tokens: { childrenGap: 32, padding: '48px 10px' }, styles: {
            root: {
                width: '100%',
                height: '100%',
                '> *': {
                    maxWidth: 800,
                    width: '100%',
                },
            },
        } }, { children: [_jsx(Header, Object.assign({}, { subtitle, title, titleAs })), _jsx(FormError, { children: detailedErrorMessage }), children] })));
};
FormCardStackLayout.Card = FormSectionCard;
FormCardStackLayout.Header = Header;
FormCardStackLayout.Footer = FormFooter;
